/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=076daecb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=076daecb&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/www.cixinwenhua.cn/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__